"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCollectionDepth = exports.getAllResponses = exports.parseLinkHeader = exports.responseParser = exports.parseResponse = exports.filterByPropExtension = void 0;

var _map2 = _interopRequireDefault(require("lodash/fp/map"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _fromPairs2 = _interopRequireDefault(require("lodash/fromPairs"));

var _flow2 = _interopRequireDefault(require("lodash/flow"));

var _immutable = require("immutable");

var _path = require("./path");

var _unsentRequest = _interopRequireDefault(require("./unsentRequest"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const filterByPropExtension = (extension, propName) => arr => arr.filter(el => (0, _path.fileExtension)((0, _get2.default)(el, propName)) === extension);

exports.filterByPropExtension = filterByPropExtension;

const catchFormatErrors = (format, formatter) => res => {
  try {
    return formatter(res);
  } catch (err) {
    throw new Error("Response cannot be parsed into the expected format (".concat(format, "): ").concat(err.message));
  }
};

const responseFormatters = (0, _immutable.fromJS)({
  json: async res => {
    const contentType = res.headers.get('Content-Type');

    if (!contentType.startsWith('application/json') && !contentType.startsWith('text/json')) {
      throw new Error("".concat(contentType, " is not a valid JSON Content-Type"));
    }

    return res.json();
  },
  text: async res => res.text(),
  blob: async res => res.blob()
}).mapEntries((_ref) => {
  let [format, formatter] = _ref;
  return [format, catchFormatErrors(format, formatter)];
});

const parseResponse = async function parseResponse(res) {
  let {
    expectingOk = true,
    format = 'text'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (expectingOk && !res.ok) {
    throw new Error("Expected an ok response, but received an error status: ".concat(res.status, "."));
  }

  const formatter = responseFormatters.get(format, false);

  if (!formatter) {
    throw new Error("".concat(format, " is not a supported response format."));
  }

  const body = await formatter(res);
  return body;
};

exports.parseResponse = parseResponse;

const responseParser = options => res => parseResponse(res, options);

exports.responseParser = responseParser;
const parseLinkHeader = (0, _flow2.default)([linksString => linksString.split(','), (0, _map2.default)(str => str.trim().split(';')), (0, _map2.default)((_ref2) => {
  let [linkStr, keyStr] = _ref2;
  return [keyStr.match(/rel="(.*?)"/)[1], linkStr.trim().match(/<(.*?)>/)[1].replace(/\+/g, '%20')];
}), _fromPairs2.default]);
exports.parseLinkHeader = parseLinkHeader;

const getAllResponses = async function getAllResponses(url) {
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  let linkHeaderRelName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'next';
  const maxResponses = 30;
  let responseCount = 1;

  let req = _unsentRequest.default.fromFetchArguments(url, options);

  const pageResponses = [];

  while (req && responseCount < maxResponses) {
    const pageResponse = await _unsentRequest.default.performRequest(req);
    const linkHeader = pageResponse.headers.get('Link');
    const nextURL = linkHeader && parseLinkHeader(linkHeader)[linkHeaderRelName];
    const {
      headers = {}
    } = options;
    req = nextURL && _unsentRequest.default.fromFetchArguments(nextURL, {
      headers
    });
    pageResponses.push(pageResponse);
    responseCount++;
  }

  return pageResponses;
};

exports.getAllResponses = getAllResponses;

const getCollectionDepth = collection => {
  const depth = collection.get('path', '').split('/').length;
  return depth;
};

exports.getCollectionDepth = getCollectionDepth;